import {
  Checkbox as CheckboxComponent,
  Color,
  SkeletonText as SkeletonTextComponent,
  Spacing,
  Text as TextComponent,
} from '@billy/design-system'
import styled from '@emotion/styled'

interface TaskItemProps {
  greyedOut?: boolean
  crossedOff?: boolean
}

interface CheckboxContainerProps {
  disabled?: boolean
}

export const SideElementsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const SkeletonContainer = styled.ul`
  flex: 1;
  margin-top: ${Spacing.S12};
  overflow: auto;
`

// TODO retheming 2026 - get rid of (Text), which is an antipattern
export const Text = styled(TextComponent)`
  margin-left: 28px;
`

export const TaskItem = styled.li<TaskItemProps>`
  margin-bottom: ${Spacing.S8};
  padding-bottom: ${Spacing.S8};
  border-bottom: 1px solid ${Color.Grey200};

  &:last-of-type {
    border-bottom: none;
  }

  ${Text} {
    color: ${Color.Grey500};
    text-decoration: ${({ crossedOff }) => (crossedOff ? 'line-through' : 'none')};
  }

  input[type='text'] {
    color: ${({ greyedOut }) => greyedOut && Color.Grey500};
    text-decoration: ${({ crossedOff }) => (crossedOff ? 'line-through' : 'none')};
  }
`

export const SkeletonText = styled(SkeletonTextComponent)`
  margin-bottom: ${Spacing.S24};
`

export const Footer = styled.footer`
  margin-top: ${Spacing.S8};
  margin-bottom: -${Spacing.S8};
`

export const TaskInfoRow = styled.div`
  display: flex;
  position: relative;
`

export const TaskDeadlineRow = styled(TaskInfoRow)`
  margin-top: -${Spacing.S8};
`

export const CheckboxContainer = styled.div<CheckboxContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  position: absolute;
  top: 0;
  left: ${Spacing.S4};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  pointer-events: ${({ disabled }) => disabled && 'none'};

  ${() => Checkbox} {
    pointer-events: none;
  }
`

export const Checkbox = styled(CheckboxComponent)``

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  height: 32px;
  margin-left: ${Spacing.S16};
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: right;
`
